// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Dashboard from '../components/Dashboard';
import {actions as DashboardAction} from '../duck';
import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    pageViews: state.dashboard.pageViews,
    orderData: state.dashboard.orderData,
    productsCount: state.dashboard.productsCount,
    productCategoryData: state.dashboard.productCategoryData,
    productData: state.dashboard.productData,
    salesData: state.dashboard.salesData,
    currency: state.currency.currency,
    dateIni: state.dashboard.dateIni,
    errorAnalyticsFetched: state.dashboard.error,
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
    points: state.referral.availablePoints,
    subscription: state.tiersList.currentSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    dueInformation: state.tiersList.dueInformation,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...DashboardAction}, dispatch)
)(Dashboard);
